import { render } from "./FPluginRecord.vue?vue&type=template&id=a22439ce&scoped=true"
import script from "./FPluginRecord.vue?vue&type=script&lang=js"
export * from "./FPluginRecord.vue?vue&type=script&lang=js"

import "./FPluginRecord.vue?vue&type=style&index=0&id=a22439ce&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22439ce"]])

export default __exports__